import styled, { css } from "styled-components";

import { Styled } from "@8x8/oxygen-modal";
import { CardIcon, DatabaseIcon, UserIcon } from "@8x8/oxygen-icon";

export const InfoBox = styled.div`
  flex: 1;

  display: grid;
  grid-template-columns: 24px auto 1fr;
  align-items: center;
  gap: 4px;
`;

export const ActionBox = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 64px;

  display: flex;
  justify-content: center;
  align-items: center;
`;

/**
 * Icons
 */
export const iconCss = css``;
export const DefaultIcon = styled(UserIcon)`
  ${iconCss}
`;
export const PBXIcon = styled(DatabaseIcon)`
  ${iconCss}
`;
export const CustomerIcon = styled(CardIcon)`
  ${iconCss}
`;
export const TenantIcon = styled(DatabaseIcon)`
  ${iconCss}
`;

/**
 * Row-level Styles
 */
export const Row = styled.div`
  display: contents; /* Ensures the row itself does not interfere with the grid layout */
`;

export const RowContent = styled.div`
  flex: 1;

  display: flex;
  align-items: center;
`;

export const KeyLabel = styled.span`
  margin-right: 4px;
  font-weight: ${({ theme }) => theme.bodyBold02.fontWeight};
`;

const { HeaderContainer } = Styled;

/**
 * This wrapper should contain the ModalHeader, ModalContent
 * and ModalFooter in order to apply custom styles to them.
 *
 * NOTE: Styled.Content and Styled.Container DO NOT work, so
 *  workarounds need to be used for those.
 */
export const CustomWrapper = styled.div`
  ${HeaderContainer} {
    display: flex;
    flex-direction: column;

    align-items: flex-start;
    justify-content: space-between;
    padding: 16px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 600px;
`;
